/** @typedef {import('@basqet-dashboard/common/types/auth').Merchant} Merchant */
/** @typedef {import('@basqet-dashboard/common/types/api').ApiResponse} ApiResponse */

import { instance } from '@basqet-dashboard/common/config/api';

/**
 * @param {Partial<Merchant> & { merchantId: string }} body
 * @returns {Promise<ApiResponse<Merchant>>}
 */
const updateMerchant = async (body) => {
  const { merchantId, ...rest } = body;
  const { data } = await instance.patch(`merchant/${merchantId}`, { ...rest });
  return data;
};

/**
 * @param {{ currency?: number, settlement_currency?: number }} body
 * @returns {Promise<ApiResponse<object>>}
 */
const updateSettlementCurrency = async (body) => {
  const currency = body.currency ?? body.settlement_currency;
  const { data } = await instance.patch('merchant/meta/settlement-currency', { currency });
  return data;
};

/** @returns {Promise<ApiResponse<object>>} */
const disableAutoSettlement = async () => {
  const { data } = await instance.patch('merchant/meta/settlement-currency/reset');
  return data;
};

/**
 * @param {{ pass_fee_to_customer: boolean }} body
 * @returns {Promise<ApiResponse<object>>}
 */
const updatePassFeeToCustomer = async (body) => {
  const { data } = await instance.patch('merchant/meta/pass-fee-to-customer', body);

  return data;
};

/**
 * Update the merchant's global settlement preference. The endpoint responds
 * 204 No Content on success. `currency_id` is required for SPECIFIC_CURRENCY
 * type and must be omitted for the other two types — see
 * basquet-backend/src/api/schema/merchant.schema.ts (updateSettlementPreferenceSchema).
 *
 * @param {{ type: string, currency_id?: number | null }} body
 * @returns {Promise<ApiResponse<null>>}
 */
const updateSettlementPreference = async (body) => {
  const { data } = await instance.patch('merchant/meta/settlement-preference', body);
  return data;
};

export {
  disableAutoSettlement,
  updateMerchant,
  updatePassFeeToCustomer,
  updateSettlementCurrency,
  updateSettlementPreference
};
